import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi, { UPLOAD_TIMEOUT } from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import download from 'downloadjs'
import { DateTime } from 'luxon'
import AlertDialog from 'components/AlertDialog'
import { FaDownload, FaTrash } from 'react-icons/fa'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'

import {
  Container,
  InfoText,
  Row,
  Button
} from './styles'

export default function Attachment ({
  data: attachment,
  onDelete: handleDelete
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [downloading, setDownloading] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleDownload = async () => {
    setDownloading (true)

    try {
      const { data } = await cutileiApi.get (
        `/attachments/${attachment.id}`,
        {responseType: 'blob', timeout: UPLOAD_TIMEOUT, ...requestConfig}
      )
  
      setDownloading (false)
      download (data, attachment.file_name)
    } catch (error) {
      setDownloading (false)
      logApiError (error)
    }
  }

  const deleteAttachment = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (`/attachments/${attachment.id}`, requestConfig)
      setDeleting (false)
      handleDelete (attachment)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container>
      <InfoText style={{justifySelf: 'flex-start'}}>
        {DateTime.fromISO (attachment.created_at).toFormat ('dd/MM/yyyy - HH:mm:ss')}
      </InfoText>
      <InfoText>
        {attachment.file_name}
      </InfoText>
      <Row style={{justifySelf: 'flex-end'}}>
        <Button onClick={handleDownload}>
          {downloading ? (
            <ButtonLoading style={{ margin: 0 }}/>
          ) : (
            <FaDownload color='#35A7FF' size={16}/>
          )}
        </Button>
        {AuthService.hasPermission ('customers', 'delete') && (
          <Button onClick={toggleAlertDialog}>
            {deleting ? (
              <ButtonLoading style={{margin: 0}}/>
            ) : (
              <FaTrash color='#FF3939' size={16}/>
            )}
          </Button>
        )}
      </Row>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente excluir este anexo?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteAttachment}
        onClose={toggleAlertDialog}
        dangerous={true}
      />
    </Container>
  )
}
